export const decodeCurrencySymbol = (symbol) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = symbol;
  return textarea.value;
};

const CURRENCY_TO_LOCALE_MAP = {
  'AUD': 'en-AU',
  'USD': 'en-US',
  'GBP': 'en-GB',
  'EUR': 'de-DE',
  'JPY': 'ja-JP',
  'CNY': 'zh-CN',
};

export const getCurrencySymbol = (currencyCode = 'AUD') => {
  const locale = CURRENCY_TO_LOCALE_MAP[currencyCode] || 'en-AU';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  })
  .formatToParts(0)
  .find(part => part.type === 'currency')
  .value;
};


export const formatCurrency = (value, currency, decimals = false) => {
  const locale = CURRENCY_TO_LOCALE_MAP[currency] || 'en-AU';

  const options = {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol'
  };

  if (decimals) {
    options.maximumFractionDigits = decimals;
  }

  return new Intl.NumberFormat(locale, options).format(value);
};
